import { createPortal } from 'react-dom';
import { FaPenToSquare } from 'react-icons/fa6';
import MapPinnedSvg from '../../assets/icons/mapPinned.svg';
import { useAddressModalStore } from '../../store/address/addressModalStore';
import {
    AddressCardWrapper,
    AddressInfo,
    AddressText,
    Title,
    TopDiv,
} from '../../templates/Checkout/AddressCard/styles';
import { ModalAddress } from '../../templates/ModalAddress';
import { BigButton } from '../BigButton';
import { useEffect } from 'react';
import { useUserProfile } from '../../hooks/useUserData';
import { useShoppingCartStore } from '../../store/shoppingCart/shoppingCartStore';
import useCountryCodes from '../../hooks/useCountryCodes';

const AddressButton = ({ customText }: { customText?: string }) => {
    const addressModal = useAddressModalStore();
    const userProfile = useUserProfile();
    const addressShoppingCart = useShoppingCartStore();
    const countryCodes = useCountryCodes();

    const handleSpawnModal = (e: any) => {
        e.stopPropagation();
        e.preventDefault();
        addressModal.update({ isVisible: true });
    };

    function handleCheckAddress() {
        if (addressModal.address.foreigner) {
            return !!addressModal.address.zipCode;
        } else {
            return !!(
                addressModal.address.address &&
                addressModal.address.number &&
                addressModal.address.neighborhood &&
                addressModal.address.city &&
                addressModal.address.state
            );
        }
    }

    useEffect(() => {
        if (addressModal.hasBeenModified) return;
        if (!countryCodes.data) return;
        if (!userProfile.data || userProfile.data?.addresses.length === 0)
            return;

        const addresses = userProfile.data.addresses.filter(
            d => d.active && !d.foreigner
        );

        const lastAddress = addresses[addresses.length - 1];
        if (!lastAddress) return;

        const address = {
            foreigner: lastAddress.foreigner,
            address: lastAddress.address,
            number: lastAddress.number,
            neighborhood: lastAddress.neighborhood,
            city: lastAddress.city,
            state: lastAddress.state,
            complement: lastAddress.complement,
            zipCode: lastAddress.zipCode,
            countryIso2: 'BR',
        };

        addressModal.update({
            isValid: true,
            address,
        });
        const countryId = countryCodes.data.find(
            code => code.iso2 === address.countryIso2
        );
        if (!countryId) return;

        addressShoppingCart.setAddress({
            foreigner: lastAddress.foreigner,
            address: lastAddress.address,
            number: lastAddress.number,
            neighborhood: lastAddress.neighborhood,
            city: lastAddress.city,
            state: lastAddress.state,
            complement: lastAddress.complement,
            zipCode: lastAddress.zipCode,
            countryId: countryId.id,
        });
    }, [
        addressModal.hasBeenModified,
        userProfile.data?.addresses,
        countryCodes.data,
    ]);

    return (
        <AddressCardWrapper>
            {(!handleCheckAddress() && (
                <BigButton
                    bgColor="primary"
                    color="primary"
                    allWidth={true}
                    onClick={handleSpawnModal}
                    type="button"
                >
                    <img src={MapPinnedSvg} alt="map-pinned" />
                    Adicionar {customText || 'Local de Faturamento'}
                </BigButton>
            )) || (
                <AddressInfo>
                    <TopDiv>
                        <Title>{customText || 'Local de Faturamento'}</Title>
                        <FaPenToSquare
                            color="#71717A"
                            onClick={handleSpawnModal}
                            cursor={'pointer'}
                        />
                    </TopDiv>
                    <AddressText>
                        {!addressModal.address.foreigner
                            ? `
                                ${addressModal.address.zipCode}, 
                                ${addressModal.address.address} - 
                                ${addressModal.address.number},
                                ${addressModal.address.neighborhood},
                                ${addressModal.address.city} -
                                ${addressModal.address.state},
                                ${addressModal.address.complement}
                            `
                            : `
                                ${addressModal.address.zipCode}
                            `}
                    </AddressText>
                </AddressInfo>
            )}
            {createPortal(<ModalAddress />, document.getElementById('root')!)}
        </AddressCardWrapper>
    );

    // return (
    //     <>
    //         <BigButton
    //             bgColor="primary"
    //             color="primary"
    //             allWidth={true}
    //             onClick={handleSpawnModal}
    //         >
    //             <img src={MapPinnedSvg} alt="map-pinned" />
    //             Adicionar Local de Faturamento
    //         </BigButton>
    //         {createPortal(modalElement, document.getElementById('root')!)}
    //     </>
    // );
};

export default AddressButton;
